import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const sections = [
  { id: 'overview', label: 'Overview' },
  { id: 'data-collected', label: 'Data We Collect' },
  { id: 'how-we-use', label: 'How We Use Data' },
  { id: 'data-retention', label: 'Data Retention' },
  { id: 'third-party', label: 'Third-Party Services' },
  { id: 'user-rights', label: 'Your Rights' },
  { id: 'cookies', label: 'Cookies & Tracking' },
  { id: 'security', label: 'Security' },
  { id: 'contact', label: 'Contact Us' },
];

const MobileNavMenu = ({ activeSection, onSectionClick }) => {
  const [open, setOpen] = useState(false);

  const handleClick = (id) => {
    onSectionClick?.(id);
    setOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 lg:hidden">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, scale: 0.9, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.9, y: 10 }}
            transition={{ duration: 0.2 }}
            className="absolute bottom-16 right-0 bg-card border border-border rounded-2xl shadow-xl p-3 w-56 space-y-1"
          >
            {sections?.map((section) => (
              <button
                key={section?.id}
                onClick={() => handleClick(section?.id)}
                className={`w-full text-left px-3 py-2 rounded-lg text-sm transition-colors ${
                  activeSection === section?.id
                    ? 'bg-primary/10 text-primary font-medium' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
                }`}
              >
                {section?.label}
              </button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
      <motion.button
        onClick={() => setOpen(!open)}
        whileTap={{ scale: 0.92 }}
        className="w-12 h-12 bg-primary rounded-full shadow-lg flex items-center justify-center text-white"
      >
        <Icon name={open ? 'X' : 'List'} size={20} color="white" />
      </motion.button>
    </div>
  );
};

export default MobileNavMenu;
